import React, { FunctionComponent } from 'react';
import LayoutWrapper from '../../../layouts/layout-wrapper/LayoutWrapper';
import {
  goToPage,
  buildAgencyByLocalityURLObject,
  buildEvaluationByLocalityURLObject,
  buildEvaluationURLObject,
} from '../../../utils/links';
import * as styles from './RapidLinks.style';

export interface RapidLinksProps extends React.AriaAttributes {
  withoutPad?: boolean,
  locality: {
    slug: string,
    name: string,
  },
  title?: string,
  showAgency?: boolean,
  showEvaluation?: boolean,
  fallbackEvaluation?: boolean,
}

const RapidLinks: FunctionComponent<RapidLinksProps> = ({
  withoutPad,
  title,
  showAgency,
  showEvaluation,
  fallbackEvaluation,
  locality,
  ...rest
}) => {
  const agencyByCityURLObject = buildAgencyByLocalityURLObject({ locality: locality.slug });
  const evaluationByCityURLObject = buildEvaluationByLocalityURLObject({ locality: locality.slug });
  const evaluationURLObject = buildEvaluationURLObject();

  return (
    <LayoutWrapper
      {...rest}
      withoutPad={withoutPad}
    >
      {title && (
        <h3 css={styles.rapidLinksTitle}>{title}</h3>
      )}
      <ul>
        {showAgency && (
          <li css={styles.rapidLinksItem}>Scopri i vantaggi dell&apos;
            <a
              onClick={() => goToPage(agencyByCityURLObject)}
              href={agencyByCityURLObject.as}
            >
              agenzia immobiliare a {locality.name}
            </a>
            &nbsp;Dove.it.
          </li>
        )}
        {showEvaluation && (
          <li css={styles.rapidLinksItem}>
            Scopri la nostra{' '}
            <a
              onClick={() => goToPage(evaluationByCityURLObject)}
              href={evaluationByCityURLObject.as}
            >
              valutazione immobile a {locality.name}
            </a>.
          </li>
        )}
        {fallbackEvaluation && !showEvaluation && (
          <li css={styles.rapidLinksItem}>
            Scopri la nostra{' '}
            <a
              onClick={() => goToPage(evaluationURLObject)}
              href={evaluationURLObject.as}
            >
              valutazione immobile
            </a>.
          </li>
        )}
      </ul>
    </LayoutWrapper>
  );
};

export default RapidLinks;
